import React from 'react';

const DocumentIcon: React.FC<{color: string, size?: string}> = (props) => {
    const iconSize = props.size ?? '1.8rem';
    return (
        <div
            className="fa-layers fa-fw"
            style={{fontSize: iconSize, color: props.color}}
        >
            <i className={'fas fa-file-alt'}/>
        </div>
    );
};

export default DocumentIcon;